<div class="gp-card-shell parent-details-card">
  <div class="gp-card-header">
    <div class="gp-card-icon"><i class="pi pi-users"></i></div>
    <div class="gp-card-title-wrap">
      <h3 class="gp-card-title">Parent Details</h3>
      <p class="gp-card-subtitle">{{ lastUpdatedText }}</p>
    </div>
  </div>

  <form [formGroup]="parentDetailsForm" (ngSubmit)="onSubmit()" class="parent-form">

    <!-- Father's Details -->
    <div class="form-section">
      <div class="section-label">
        <div class="label-accent"></div>
        <span>FATHER'S DETAILS</span>
      </div>

      <div class="form-row two-col">
        <div class="form-field">
          <label>Full Name</label>
          <input type="text" formControlName="fatherFullName" class="form-input"
            [ngClass]="{'ng-invalid ng-dirty': submitted && parentDetailsForm.get('fatherFullName')?.invalid}"
            placeholder="Enter full name" />
          <div class="error-msg" *ngIf="submitted && parentDetailsForm.get('fatherFullName')?.errors?.['required']">
            Name is required.
          </div>
        </div>
        <div class="form-field">
          <label>Email</label>
          <input type="email" formControlName="fatherEmail" class="form-input"
            [ngClass]="{'ng-invalid ng-dirty': submitted && parentDetailsForm.get('fatherEmail')?.invalid}"
            placeholder="Enter email address" />
          <div class="error-msg" *ngIf="submitted && parentDetailsForm.get('fatherEmail')?.errors?.['required']">
            Email is required.
          </div>
          <div class="error-msg" *ngIf="submitted && parentDetailsForm.get('fatherEmail')?.errors?.['email']">
            Invalid email format.
          </div>
        </div>
      </div>

      <div class="form-row single-col">
        <div class="form-field">
          <label>Mobile Number</label>
          <input type="tel" formControlName="fatherPhone" class="form-input"
            [ngClass]="{'ng-invalid ng-dirty': (submitted || parentDetailsForm.get('fatherPhone')?.dirty) && parentDetailsForm.get('fatherPhone')?.invalid}"
            placeholder="Enter mobile number" />
          <div class="error-msg" *ngIf="(submitted || parentDetailsForm.get('fatherPhone')?.dirty) && parentDetailsForm.get('fatherPhone')?.errors?.['required']">
            Mobile number is required.
          </div>
          <div class="error-msg" *ngIf="(submitted || parentDetailsForm.get('fatherPhone')?.dirty) && parentDetailsForm.get('fatherPhone')?.errors?.['nonDigit']">
            Invalid mobile number (only numbers allowed).
          </div>
          <div class="error-msg" *ngIf="(submitted || parentDetailsForm.get('fatherPhone')?.dirty) && parentDetailsForm.get('fatherPhone')?.errors?.['lengthError']">
            Mobile number must be exactly 10 digits.
          </div>
        </div>
      </div>
    </div>

    <!-- Mother's Details -->
    <div class="form-section">
      <div class="section-label">
        <div class="label-accent"></div>
        <span>MOTHER'S DETAILS</span>
      </div>

      <div class="form-row two-col">
        <div class="form-field">
          <label>Full Name</label>
          <input type="text" formControlName="motherFullName" class="form-input"
            placeholder="Enter full name" />
        </div>
        <div class="form-field">
          <label>Email</label>
          <input type="email" formControlName="motherEmail" class="form-input"
            [ngClass]="{'ng-invalid ng-dirty': submitted && parentDetailsForm.get('motherEmail')?.invalid}"
            placeholder="Enter email address" />
          <div class="error-msg" *ngIf="submitted && parentDetailsForm.get('motherEmail')?.errors?.['required']">
            Email is required.
          </div>
          <div class="error-msg" *ngIf="submitted && parentDetailsForm.get('motherEmail')?.errors?.['email']">
            Invalid email format.
          </div>
        </div>
      </div>

      <div class="form-row single-col">
        <div class="form-field">
          <label>Mobile Number</label>
          <input type="tel" formControlName="motherPhone" class="form-input"
            [ngClass]="{'ng-invalid ng-dirty': (submitted || parentDetailsForm.get('motherPhone')?.dirty) && parentDetailsForm.get('motherPhone')?.invalid}"
            placeholder="Enter mobile number" />
          <div class="error-msg" *ngIf="(submitted || parentDetailsForm.get('motherPhone')?.dirty) && parentDetailsForm.get('motherPhone')?.errors?.['nonDigit']">
            Invalid mobile number (only numbers allowed).
          </div>
          <div class="error-msg" *ngIf="(submitted || parentDetailsForm.get('motherPhone')?.dirty) && parentDetailsForm.get('motherPhone')?.errors?.['lengthError']">
            Mobile number must be exactly 10 digits.
          </div>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button type="submit" class="submit-btn" [disabled]="loading">
        {{ loading ? 'Saving...' : 'Update Details' }}
      </button>
    </div>
  </form>
</div>
